// polyfills
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import "@ungap/custom-elements";

// Intl.DisplayNames polyfill
(() => {
    if (!window.Intl || !window.Intl.DisplayNames) {
        const script = document.createElement("script");
        script.src =
            "https://polyfill-fastly.io/v3/polyfill.min.js?features=Intl.DisplayNames,Intl.DisplayNames.~locale.en,Intl.DisplayNames.~locale.de";
        script.async = true;
        document.head.appendChild(script);
    }
})();

(() => {
    try {
        new window.ImageData(new Uint8ClampedArray([0, 0, 0, 0]), 1, 1);
    } catch (e) {
        // eslint-disable-next-line no-inner-declarations
        function ImageDataPolyfill() {
            // eslint-disable-next-line prefer-rest-params,prefer-const
            let args = [...arguments],
                data;

            if (args.length < 2) {
                throw new TypeError(`
          Failed to construct 'ImageData': 2 arguments required, but only ${args.length} present.
        `);
            }

            if (args.length > 2) {
                data = args.shift();

                if (!(data instanceof Uint8ClampedArray)) {
                    throw new TypeError(`
            Failed to construct 'ImageData': parameter 1 is not of type 'Uint8ClampedArray'
          `);
                }

                if (data.length !== 4 * args[0] * args[1]) {
                    throw new Error(`
            Failed to construct 'ImageData': The input data byte length is not a multiple of (4 * width * height)
          `);
                }
            }

            const width = args[0],
                height = args[1],
                canvas = document.createElement("canvas"),
                ctx = canvas.getContext("2d"),
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                imageData = ctx.createImageData(width, height);

            if (data) imageData.data.set(data);
            return imageData;
        }

        window.ImageData = ImageDataPolyfill;
    }
})();

// titanOS compatibility polyfill for setWindowId
// Some titanOS models (e.g., 2K24) may not have this function available
if (typeof (window as any).setWindowId === "undefined") {
    (window as any).setWindowId = function (windowId: number) {
        console.log(`[titanOS polyfill] setWindowId(${windowId}) called but not available on this device`);
        // Silently handle the call to prevent ReferenceError
        // This function is typically used for multi-window management in titanOS
        return true;
    };
    console.log("[titanOS polyfill] setWindowId polyfill installed for compatibility");
}
